import { render, staticRenderFns } from "./CloseX.vue?vue&type=template&id=76355e98&scoped=true"
import script from "./CloseX.vue?vue&type=script&lang=js"
export * from "./CloseX.vue?vue&type=script&lang=js"
import style0 from "./CloseX.vue?vue&type=style&index=0&id=76355e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76355e98",
  null
  
)

export default component.exports